import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

export default function NewsPage() {
  const newsItems = [
    {
      id: 1,
      date: '2024年12月',
      category: 'プレスリリース',
      categoryColor: 'from-teal-500 to-blue-500',
      title: '【プレスリリース】クラファン開始のお知らせ',
      summary: '居場所の人手不足をオンラインで支える学習支援サービス『ボラタス』の利用ポイントを、クラファンで居場所へ届ける取り組みを開始しました。',
      link: '/news/cf-press-release',
      isExternal: false,
      image: 'https://public.readdy.ai/ai/img_res/7988a2b1d2a87492114a9d3c248d16e3.jpg'
    },
    {
      id: 4,
      date: '2025年1月',
      category: 'ボランティア募集',
      categoryColor: 'from-amber-500 to-orange-500',
      title: 'ボランティア募集のお知らせ',
      summary: 'オンラインで、こどもたちの「わからない」に寄り添う学習サポートボランティアを募集しています。',
      link: '/news/volunteer-recruitment',
      isExternal: false,
      image: 'https://readdy.ai/api/search-image?query=heartwarming%20illustration%20of%20online%20volunteer%20tutoring%20and%20educational%20support%2C%20caring%20mentor%20helping%20children%20with%20studies%20through%20computer%20screen%2C%20warm%20amber%20and%20orange%20colors%2C%20encouraging%20and%20supportive%20atmosphere%2C%20simple%20clean%20background%20emphasizing%20connection%20and%20learning%20together&width=600&height=400&seq=news-volunteer&orientation=landscape'
    },
    {
      id: 2,
      date: '2024年11月',
      category: '募集',
      categoryColor: 'from-orange-500 to-amber-500',
      title: '居場所募集のお知らせ',
      summary: 'ボラタスを活用いただける居場所を募集しています。子どもたちの学習支援に興味のある団体・施設の皆さま、ぜひご参加ください。',
      link: 'https://kyo-colle.com/ibasho-cf/index.html',
      isExternal: true,
      image: 'https://readdy.ai/api/search-image?query=welcoming%20illustration%20of%20Japanese%20community%20center%20recruitment%2C%20open%20doors%20with%20warm%20light%2C%20inviting%20atmosphere%20for%20volunteers%20and%20children%2C%20soft%20orange%20and%20yellow%20colors%2C%20hopeful%20and%20encouraging%20mood%2C%20simple%20background%20emphasizing%20community%20and%20connection&width=600&height=400&seq=news-recruit&orientation=landscape'
    },
    {
      id: 3,
      date: '2024年10月',
      category: '支援募集',
      categoryColor: 'from-pink-500 to-rose-500',
      title: 'クラウドファンディング実施中',
      summary: '財恩工房の活動を支援してくださる方を募集しています。皆さまのご支援が、子どもたちの未来を支える力になります。',
      link: 'https://for-good.net/project/1003002',
      isExternal: true,
      image: 'https://readdy.ai/api/search-image?query=heartwarming%20illustration%20of%20crowdfunding%20and%20community%20support%2C%20hands%20coming%20together%20to%20help%20children%2C%20donation%20and%20support%20concept%2C%20warm%20pink%20and%20rose%20colors%2C%20caring%20and%20compassionate%20atmosphere%2C%20simple%20clean%20background%20emphasizing%20unity%20and%20hope&width=600&height=400&seq=news-support&orientation=landscape'
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      {/* Hero Section */}
      <section className="relative pt-32 pb-20 px-4 bg-gradient-to-br from-teal-50 via-orange-50 to-amber-50">
        <div className="max-w-7xl mx-auto text-center">
          <div className="inline-block mb-6">
            <div className="w-20 h-20 bg-gradient-to-br from-teal-500 to-orange-500 rounded-2xl flex items-center justify-center mx-auto shadow-lg">
              <i className="ri-notification-line text-4xl text-white"></i>
            </div>
          </div>
          <h1 className="text-4xl md:text-6xl font-bold text-gray-900 mb-6">
            ニュース / お知らせ
          </h1>
          <p className="text-lg md:text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed mb-4">
            財恩工房からの公式なお知らせ・プレスリリースを掲載します
          </p>
          <p className="text-base text-teal-700 font-medium">
            支援者を支援することで、こどもたちの学びを支える取り組みを発信しています
          </p>
        </div>
      </section>

      {/* News List Section */}
      <section className="py-20 px-4">
        <div className="max-w-7xl mx-auto">
          <div className="space-y-8">
            {newsItems.map((item) => (
              <article
                key={item.id}
                className="group bg-white rounded-3xl overflow-hidden shadow-lg hover:shadow-2xl transition-all border-2 border-gray-100 hover:border-teal-200"
              >
                <div className="grid md:grid-cols-5 gap-0">
                  {/* Image */}
                  <div className="md:col-span-2 relative h-64 md:h-auto overflow-hidden">
                    <img 
                      src={item.image}
                      alt={item.title}
                      className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                    />
                    <div className={`absolute top-4 left-4 px-4 py-2 bg-gradient-to-r ${item.categoryColor} rounded-full shadow-lg`}>
                      <span className="text-white font-bold text-sm whitespace-nowrap">{item.category}</span>
                    </div>
                  </div>

                  {/* Content */}
                  <div className="md:col-span-3 p-8 flex flex-col justify-center">
                    <div className="flex items-center space-x-3 mb-4">
                      <div className="flex items-center text-gray-500">
                        <i className="ri-calendar-line mr-2"></i>
                        <time className="text-sm">{item.date}</time>
                      </div>
                    </div>

                    <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-4 group-hover:text-teal-600 transition-colors">
                      {item.title}
                    </h2>

                    <p className="text-gray-600 leading-relaxed mb-6">
                      {item.summary}
                    </p>

                    {item.isExternal ? (
                      <a
                        href={item.link}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="inline-flex items-center text-teal-600 font-bold hover:text-teal-700 transition-colors group-hover:translate-x-2 transition-transform cursor-pointer"
                      >
                        詳しく見る
                        <i className="ri-external-link-line ml-2"></i>
                      </a>
                    ) : (
                      <a
                        href={item.link}
                        className="inline-flex items-center text-teal-600 font-bold hover:text-teal-700 transition-colors group-hover:translate-x-2 transition-transform cursor-pointer"
                      >
                        続きを読む
                        <i className="ri-arrow-right-line ml-2"></i>
                      </a>
                    )}
                  </div>
                </div>
              </article>
            ))}
          </div>

          {/* Coming Soon Notice */}
          <div className="mt-16 text-center p-12 bg-gradient-to-br from-gray-50 to-white rounded-3xl border-2 border-gray-100">
            <div className="w-16 h-16 bg-gradient-to-br from-teal-500 to-blue-500 rounded-full flex items-center justify-center mx-auto mb-6">
              <i className="ri-time-line text-3xl text-white"></i>
            </div>
            <h3 className="text-2xl font-bold text-gray-900 mb-4">
              今後の予定
            </h3>
            <p className="text-gray-600 leading-relaxed max-w-2xl mx-auto">
              ボランティア募集など、新しいお知らせを順次掲載していきます。<br />
              最新情報をお見逃しなく。
            </p>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 px-4 bg-gradient-to-r from-teal-600 to-orange-600">
        <div className="max-w-4xl mx-auto text-center text-white">
          <h2 className="text-3xl md:text-5xl font-bold mb-6">
            一緒に活動しませんか？
          </h2>
          <p className="text-lg md:text-xl mb-12 opacity-90">
            財恩工房の取り組みに興味をお持ちの方、ぜひお問い合わせください
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a 
              href="https://boratasu.com" 
              target="_blank" 
              rel="noopener noreferrer"
              className="bg-white text-teal-600 px-10 py-5 rounded-xl font-bold text-lg hover:bg-gray-100 transition-all shadow-2xl hover:shadow-3xl whitespace-nowrap cursor-pointer inline-block transform hover:scale-105"
            >
              <i className="ri-smartphone-line mr-2"></i>
              サービスを使ってみる
            </a>
            <a 
              href="/contact"
              className="bg-transparent border-2 border-white text-white px-10 py-5 rounded-xl font-bold text-lg hover:bg-white hover:text-teal-600 transition-all shadow-2xl hover:shadow-3xl whitespace-nowrap cursor-pointer inline-block transform hover:scale-105"
            >
              <i className="ri-mail-line mr-2"></i>
              お問い合わせ
            </a>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
